/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

export function validateScreenEvent(name: string): void {
	if (!name) {
		throw new Error('Missing name');
	}
}
